import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, Landmark, ArrowRight } from "lucide-react";
import { SectionHeader } from "./_shared";

function HowItWorksStepper({ steps, testIdPrefix }) {
  return (
    <ol className="relative border-l border-navy/15 pl-5 space-y-3.5" data-testid={`${testIdPrefix}-stepper`}>
      {steps.map((s, i) => (
        <li key={s} className="relative">
          <span className="absolute -left-[27px] top-1 w-4 h-4 rounded-full bg-navy text-cream text-[10px] font-mono flex items-center justify-center">{i + 1}</span>
          <div className="text-sm text-ink">{s}</div>
        </li>
      ))}
    </ol>
  );
}

export default function HowItWorks() {
  const startupSteps = [
    "Create your Startup Passport",
    "Add CIN / LLPIN or manual profile",
    "Upload documents and financials",
    "Generate Basic Health Check",
    "Resolve readiness gaps",
    "Become visible to relevant investors",
    "Move serious interest into a secure deal room",
  ];
  const investorSteps = [
    "Create investor profile",
    "Define your mandate",
    "Explore verified opportunities",
    "View Trust Score and approved summaries",
    "Express interest",
    "Ask controlled queries",
    "Request DD access or enter deal room",
  ];
  return (
    <section className="py-16 lg:py-20 bg-white" data-testid="how-it-works-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="WORKFLOW"
          title="From profile to investor-ready in one workflow."
        />
        <div className="grid md:grid-cols-2 gap-8 mt-2">
          <div className="rounded-lg border border-navy/10 bg-cream p-6" data-testid="how-founder">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md bg-navy text-cream flex items-center justify-center"><Briefcase size={16} /></div>
              <div className="font-heading text-xl text-ink">For Startups</div>
            </div>
            <HowItWorksStepper steps={startupSteps} testIdPrefix="how-founder" />
            <Link to="/startup/apply" className="mt-6 inline-flex items-center gap-2 bg-navy text-cream px-5 py-2.5 rounded-md font-heading text-sm hover:bg-[#256E58] transition-colors" data-testid="how-founder-cta">
              Apply for Funding <ArrowRight size={14} />
            </Link>
          </div>

          <div className="rounded-lg border border-navy/10 bg-cream p-6" data-testid="how-investor">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md bg-gold text-navy flex items-center justify-center"><Landmark size={16} /></div>
              <div className="font-heading text-xl text-ink">For Investors</div>
            </div>
            <HowItWorksStepper steps={investorSteps} testIdPrefix="how-investor" />
            <Link to="/investor/join" className="mt-6 inline-flex items-center gap-2 bg-gold text-navy px-5 py-2.5 rounded-md font-heading text-sm hover:bg-gold/90 transition-colors" data-testid="how-investor-cta">
              Join as Investor <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
